/* eslint-disable prefer-template */
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import axios from '../../../utils/axios';
import { RoleType } from '../../../utils/enums.tsx';

export const API = 'manager';
export const name = 'managerSlice';

interface InitState {
  isLoading: boolean,
  isSaving: boolean,
  show: boolean,
  showForm: boolean,
  buildingId: number|null,
  items: Array<any>,
}

function NewReducer() {
  const initialState: InitState = {
    isLoading: false,
    isSaving: false,
    show: false,
    showForm: false,
    buildingId: null,
    items: [],
  };

  const reducers = {
    resetSlice: () => initialState,
    setShow: (state: InitState, action: PayloadAction<{ show: boolean, buildingId: number|null }>) => {
      state.show = action.payload.show;
      state.buildingId = action.payload.buildingId;
      if (!action.payload.show) {
        state.showForm = false;
      }
    },
    setShowForm: (state: InitState, action: PayloadAction<{ show: boolean }>) => {
      state.showForm = action.payload.show;
    },
    startRead: (state: InitState) => {
      state.isLoading = true;
      state.items = [];
    },
    finishRead: (state: InitState, action: PayloadAction<any>) => {
      state.items = (action.payload && action.payload.length > 0) ? action.payload : [];
      state.isLoading = false;
    },
    startSave: (state: InitState) => {
      state.isSaving = true;
    },
    finishSave: (state: InitState) => {
      state.isSaving = false;
    },
  };

  const slice = createSlice({
    name,
    initialState,
    reducers,
  });

  const { actions } = slice;

  const apis = {
    callReadApi: (callback: (state: boolean, data: any, message: string) => void) => async (dispatch: any) => {
      dispatch(actions.startRead());

      await axios.get('user/all', {
        params: {
          role: RoleType.Manager,
          isActive: true,
        },
      }).then((result: any) => {
        const { data, message } = result.data;

        callback(true, data, message);
        dispatch(actions.finishRead(data));
      }).catch((error: any) => {
        const { message } = error;

        callback(false, null, message);
        dispatch(actions.finishRead(null));
      });
    },

    callUpdateApi: (id: number|string, callback: (state: boolean, data: any, message: string) => void) => async (dispatch: any) => {
      dispatch(actions.startSave());

      await axios.put('building/' + id + '/manager').then((result: any) => {
        const { data, message } = result.data;

        callback(true, data, message);
        dispatch(actions.finishSave());
      }).catch((error: any) => {
        const { message } = error;

        callback(false, null, message);
        dispatch(actions.finishSave());
      });
    },

    callSaveApi: (params: any, callback: (state: boolean, data: any, message: string) => void) => async (dispatch: any, getState: any) => {
      dispatch(actions.startSave());

      const state = getState();
      const { buildingId } = state[name];

      await axios.post('building/' + buildingId + '/manager', params).then((result: any) => {
        const { data, message } = result.data;

        callback(true, data, message);
        dispatch(actions.finishSave());
      }).catch((error: any) => {
        const { message } = error;

        callback(false, null, message);
        dispatch(actions.finishSave());
      });
    },
  };

  return {
    reducer: slice.reducer,
    ...actions,
    ...apis,
  };
}

export default NewReducer();
